module.exports = __webpack_public_path__ + "img/img7.8fe6ea05.jpg";